import * as types from "./types";

export default {
  [types.STORE_UGC](state, { componentName, ugcObject, bucketSize }) {
    const { recipes } = state;
    const bucketRecipes = recipes[bucketSize] || {};
    bucketRecipes[componentName] = ugcObject;
    state.recipes = {
      ...recipes,
      [bucketSize]: bucketRecipes
    };
  },
  [types.DELETE_RECIPE](state, bucketSize) {
    delete state.recipes[bucketSize];
  },
  [types.DELETE_MULTIPLE_RECIPES](state) {
    const { recipes } = state;
    const storageRecipes = Object.keys(recipes);
    if (storageRecipes && storageRecipes.length > 1) {
      storageRecipes.forEach((bucketSize, index) => {
        if (index !== 0) {
          delete recipes[bucketSize];
        }
      });
      state.recipes = {
        ...recipes
      };
    }
  },
  [types.CLEAR_RECIPES](state) {
    state.recipes = {};
  }
};
